import { getAuth, connectAuthEmulator } from "firebase/auth"

import { app } from ".."

export const auth = getAuth(app)

if (process.env.REACT_APP_FIREBASE_EMULATION_MODE === "EMULATION") {
  connectAuthEmulator(auth, "http://localhost:9099")
}

export const actionCodeSettings = {
  url: process.env.REACT_APP_HOME_URL || "",
}
